import React, {useState, useEffect, useContext} from 'react';
import {useNavigate} from 'react-router-dom';
import {onIdTokenChanged} from 'firebase/auth';
import {isHiddenAccount} from '@embertracking/common';
import {auth} from '-/firebase';
import {UserContext} from '-/contexts/User';

import AppBanner from './AppBanner';

import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';

// Not dismissible: an unverified address is the one thing here the member can
// actually fix in a minute, and it stays true until they do. The banner goes
// away on its own the moment the address is verified.
export default function EmailVerificationBanner() {
    const {currentUser} = useContext(UserContext);
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);

    const uid = currentUser?.uid;
    const isStation = currentUser?.isStation;
    // Hidden accounts (the operator, a hub user signed in from a hub) have no
    // email address at all.
    const isHidden = isHiddenAccount(currentUser);

    useEffect(() => {
        if (!uid || isStation || isHidden) {
            setVisible(false);
            return;
        }

        // Auth has already refreshed the restored session. Reloading it again
        // here restarts Firestore listeners while the page is still loading.
        // Observe Auth's authoritative flag (not the Firestore profile/cache)
        // and keep following explicit refreshes, e.g. verification from Profile.
        return onIdTokenChanged(auth, user => {
            setVisible(user?.uid === uid && !user.emailVerified);
        });
    }, [uid, isStation, isHidden]);

    if (!visible) return null;

    return (
        <AppBanner
            tone="warning"
            icon={<MarkEmailUnreadIcon />}
            action={{label: 'Go to Profile', onClick: () => navigate('/profile'), testId: 'email-verification-banner-action'}}
            testId="email-verification-banner"
        >
            Your email address has not been verified. Please check your inbox or request a new verification email from your profile.
        </AppBanner>
    );
}
